/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarketInfoResponse
 */
export interface MarketInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    priceChangePct24h: number;
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    rank: number;
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    marketCap: number;
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    marketCapChangePct24h: number;
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    volume: number;
    /**
     * 
     * @type {number}
     * @memberof MarketInfoResponse
     */
    volumeChangePct24h: number;
}

export function MarketInfoResponseFromJSON(json: any): MarketInfoResponse {
    return MarketInfoResponseFromJSONTyped(json, false);
}

export function MarketInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': json['price'],
        'priceChangePct24h': json['priceChangePct24h'],
        'rank': json['rank'],
        'marketCap': json['marketCap'],
        'marketCapChangePct24h': json['marketCapChangePct24h'],
        'volume': json['volume'],
        'volumeChangePct24h': json['volumeChangePct24h'],
    };
}

export function MarketInfoResponseToJSON(value?: MarketInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': value.price,
        'priceChangePct24h': value.priceChangePct24h,
        'rank': value.rank,
        'marketCap': value.marketCap,
        'marketCapChangePct24h': value.marketCapChangePct24h,
        'volume': value.volume,
        'volumeChangePct24h': value.volumeChangePct24h,
    };
}


